import { useEffect, useState } from "react";
import { SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import SyncToggleComp from "./SyncToggleComp";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const EventCalendarTabsComponent = (props) => {
  const {
    getSessionsAccordingTab,
    monthHeader,
    weeksCount,
    setCurrentMonth,
    currentMonth,
    setSelectedSessionPos,
    googleSync,
    isSyncLoading,
    isHome,
    syncSessionFunc,
    setFromGuestUser,
    isLearn,
    isMobile,
    isEvents,
    isCoaching
  } = props;
  const authBroker = useSelector((state) => state.auth.authBroker);
  const [activeTab, setActiveTab] = useState("currentWeek");
  const [activeTabWeek, setActiveTabWeek] = useState("");
  let navigate = useNavigate();
const {t} = useTranslation();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const isGuest = params.get("guest");
  const tabType = params.get("tabType");
  const currentMonthParam = params.get("currentMonth");
  const activeTabWeekParam = params.get("activeTabWeek");
  const b_name = _.isEmpty(params.get("b_name"))|| params.get("b_name")===undefined ||params.get("b_name")===null?"" :atob(params.get("b_name"));


  useEffect(() => {
    if (!_.isEmpty(authBroker)||true) {
      if(isGuest!=="true"){
      setActiveTab("currentWeek");
      getSessionsAccordingTab("monthView");
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (isGuest) {

      if(tabType===undefined||!tabType){
        setActiveTab("currentWeek");
      getSessionsAccordingTab("monthView");
      }else{
      setActiveTab(tabType)
      setActiveTabWeek(activeTabWeekParam);
      setCurrentMonth(Number(currentMonthParam));
      getSessionsAccordingTab(tabType,Number(currentMonthParam),activeTabWeekParam);
      if(Number(currentMonthParam)===0){
        setActiveTab("month");
      }
      if(tabType==="today" || tabType ==="tomorrow" || tabType==="currentWeek")
      setActiveTab(tabType)
      }
      setFromGuestUser(false);
    }
  }, [isGuest]);

  return (
    <>
      { !isLearn && localStorage.getItem(SessionKeys.BROKER_NAME)!=="null" &&<div className="heading-events">
        {/* {`${isGuest==="true"?b_name:localStorage.getItem(SessionKeys.BROKER_NAME)!==null?localStorage.getItem(SessionKeys.BROKER_NAME):""}`} Training */}
        {isEvents ? "": isCoaching ? "My Coaching Sessions" : t("groupWorkshop")}
      </div>}
      <div className="d-sm-flex justify-content-between align-items-center mb-3 flex-md-wrap">
        <>
          <div className="d-flex cal_iconLR cal-btn-black">
            <button
              className="button-reset cursor-pointer"
              onClick={() => {
                let getMonth = _.cloneDeep(currentMonth) - 1;
                setCurrentMonth(getMonth);
                setActiveTab("prevMonth");
                setActiveTabWeek("monthView");
                setSelectedSessionPos(0);
                getSessionsAccordingTab("monthView", getMonth,"monthView");
              }}
              disabled={true ? "" : true}
            >
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="14" r="13.5" stroke="#415385" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1918 18.3752C14.9625 18.3752 14.7342 18.286 14.5627 18.1083L11.1825 14.6083C10.8518 14.2645 10.8562 13.7193 11.1939 13.3816L14.6939 9.88159C15.0352 9.53947 15.589 9.53947 15.9312 9.88159C16.2724 10.2237 16.2724 10.7767 15.9312 11.1188L13.0393 14.0107L15.8209 16.8921C16.1569 17.2403 16.1473 17.7942 15.7999 18.1293C15.6293 18.2938 15.4105 18.3752 15.1918 18.3752Z" fill="#415385" />
              </svg>

            </button>
            <p className="calen">{monthHeader}</p>
            <button
              className="button-reset cursor-pointer"
              onClick={() => {
                let getMonth = _.cloneDeep(currentMonth) + 1;
                setCurrentMonth(getMonth);
                setActiveTab("nextMonth");
                setActiveTabWeek("monthView");
                setSelectedSessionPos(0);
                // getSessionsAccordingTab('nextMonth',getMonth)
                getSessionsAccordingTab("monthView", getMonth,"monthView");
              }}
              disabled={true ? "" : true}
            >
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="14" r="13.5" transform="rotate(180 14 14)" stroke="#415385" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8082 9.62478C13.0375 9.62478 13.2658 9.71403 13.4373 9.89166L16.8175 13.3917C17.1482 13.7355 17.1438 14.2807 16.8061 14.6184L13.3061 18.1184C12.9648 18.4605 12.411 18.4605 12.0688 18.1184C11.7276 17.7763 11.7276 17.2233 12.0688 16.8812L14.9607 13.9893L12.1791 11.1079C11.8431 10.7597 11.8527 10.2058 12.2001 9.87066C12.3707 9.70616 12.5895 9.62478 12.8082 9.62478Z" fill="#415385" />
              </svg>

            </button>
          </div>
          {isGuest || isLearn || true? (
            ""
          ) : (
            <SyncToggleComp
              googleSync={googleSync}
              isSyncLoading={isSyncLoading}
              isHome={isHome}
              syncSessionFunc={syncSessionFunc}
              from="list"
              isMobile={isMobile}
            />
          )}
        </>
      </div>
     {false && <div className="d-flex justify-content-between gap-3 cal-mob">
        <div className="events-tabs-pills">
          <div
            className={`event-pill ${activeTab === "today" && "active-tab"}`}
            onClick={() => {
              setActiveTab("today");
              setActiveTabWeek("");
              setSelectedSessionPos(0);
              setCurrentMonth(0);
              getSessionsAccordingTab("today");
            }}
          >
            Today
          </div>
          <div
            className={`event-pill ${activeTab === "tomorrow" && "active-tab"}`}
            onClick={() => {
              setActiveTab("tomorrow");
              setActiveTabWeek("");
              setSelectedSessionPos(0);
              setCurrentMonth(0);
              getSessionsAccordingTab("tomorrow");
            }}
          >
            Tomorrow
          </div>
          <div
            className={`event-pill ${
              activeTab === "currentWeek" && "active-tab"
            }`}
            onClick={() => {
              setActiveTab("currentWeek");
              setActiveTabWeek("");
              setCurrentMonth(0);
              getSessionsAccordingTab("currentWeek");
            }}
          >
            This Week
          </div>
          <div
            className={`event-pill ${activeTab === "month" && "active-tab"}`}
            onClick={() => {
              setActiveTab("month");
              setActiveTabWeek("monthView");
              setSelectedSessionPos(0);
              setCurrentMonth(0);
              // getSessionsAccordingTab('month');
              getSessionsAccordingTab("monthView", 0,"monthView");
            }}
          >
            This Month
          </div>
        </div>
        {isGuest && false ? (
          <div>
            Already have an account?{" "}
            <span
              className="cursor-pointer text-decoration-underline"
              onClick={() => navigate("/login")}
            >
              Click here to Login!
            </span>
          </div>
        ) : (
          ""
        )}
      </div> }

      {(activeTab === "month" ||
        activeTab === "monthView" ||
        activeTab === "nextMonth" ||
        activeTab === "prevMonth" ||
        activeTab.includes("week")) && false && (
        <div className="week-pills">
          <div
            className={`wekpill ${
              activeTabWeek === "monthView" && "active-tab"
            }`}
            onClick={() => {
              setActiveTabWeek("monthView");
              setSelectedSessionPos(0);
              getSessionsAccordingTab("monthView", currentMonth,"monthView");
            }}
          >
            {"Month View"}
          </div>
          {Array.from({ length: weeksCount }, (v, i) => {
            return (
              <div
                className={`wekpill ${
                  activeTabWeek === "week" + (i + 1) && "active-tab"
                }`}
                onClick={() => {
                  setActiveTabWeek("week" + (i + 1));
                  setSelectedSessionPos(0);
                  getSessionsAccordingTab("week" + (i + 1), currentMonth,"week" + (i + 1));
                }}
              >
                {"Week " + (i + 1)}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
export default EventCalendarTabsComponent;
